import { showToast, type ToastVariant } from "@/contexts/ToastContext";
import type { AlertData } from "@/features/alerts/types/alerts.types";

class ToastService {
  private toastRef: { current: any } | null = null;

  setToast(toastRef: { current: any }) {
    this.toastRef = toastRef;
  }

  ShowToast(Alerts: AlertData) {
    const Alert: AlertData = { ...Alerts };
    Alert.severity =
      Alert.severity === "Informational" ? "Info" : Alert.severity;

    // Include Project in the title
    const severityLabel = `${Alert.severity} - ${Alert.customer?.toUpperCase()} - ${Alert.project ?? "Unknown Project"}`;

    showToast({
      variant: Alert.severity?.toLowerCase() as ToastVariant, // "critical" | "error" | "warning" | "info" | "success"
      title: severityLabel,
      message: Alert.alertName ?? "",
      life: 10000,
    });
  }

  clear() {
    this.toastRef?.current?.clear();
  }
}

const toastService = new ToastService();
export default toastService;
